/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const OutstandingActionsIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    viewBox="-1 -1 65 65"
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" strokeLinejoin="round" strokeLinecap="round" strokeWidth="3">
      <g transform="translate(29.333333, 29.333333)">
        <circle cx="16" cy="16" r="16" />
        <polyline points="22.6666667 19.1111111 16 19.1111111 16 9.77777778" />
      </g>
      <path d="M26.6666667,56 L5.33333333,56 C2.4,56 0,53.6053333 0,50.6666667 L0,8 L10.6666667,8" />
      <polyline points="24 50.6666667 5.33333333 50.6666667 5.33333333 13.3333333 10.6666667 13.3333333" />
      <polyline points="42.6666667 24 42.6666667 8 32 8" />
      <path
        d="M26.6666667,5.33333333 C26.6666667,3.12533333 25.3333333,0 21.3333333,0 C17.3333333,0 16,3.12533333 16,5.33333333 L10.6666667,5.33333333 L10.6666667,16 L32,16 L32,5.33333333 L26.6666667,5.33333333 Z"
        strokeLinecap="round"
      />
      <polyline points="32 13.3333333 37.3333333 13.3333333 37.3333333 25.3333333" />
      <path d="M13.3333333,24 L26.6666667,24" />
      <path d="M13.3333333,29.3333333 L26.6666667,29.3333333" />
      <path d="M13.3333333,34.6666667 L26.6666667,34.6666667" />
      <path d="M13.3333333,40 L21.3333333,40" />
    </g>
  </svg>
);

export default OutstandingActionsIcon;
